export default function getActive() {
  let effectIsActive = true
  const checkActive = () => effectIsActive
  const cleanupEffect = () => {
    effectIsActive = false
  }
  return { checkActive, cleanupEffect }
}
